import { Pipe, PipeTransform } from '@angular/core';

@Pipe({ name: 'stringToNumber' })
export class StringToNumber implements PipeTransform {
  transform(input: any) {
    if (
      input == undefined ||
      input == null ||
      input == '' ||
      input == 'Infinity' ||
      input == 'NaN' ||
      isNaN(parseFloat(input))
    ) {
      return 0;
    }
    return parseInt(input);
  }
}
